export interface CardConfig {
  readonly tagKey: string;
  readonly mainImageSrc: string;
  readonly mainImageAlt: string;
  readonly auroraUiKey: string;
  readonly legacyUiKey: string;
}

export const CARD_CONFIGS: CardConfig[] = [
  {
    tagKey: 'relaxed_card_tag',
    mainImageSrc: '/blue-sky/why-oura/relaxed.jpeg?flip=h',
    mainImageAlt: 'why_oura_image_lifestyle_1_alt',
    auroraUiKey: 'why_oura_relaxed_ui',
    legacyUiKey: 'relaxed_app_ui_src',
  },
  {
    tagKey: 'restored_card_tag',
    mainImageSrc: '/blue-sky/why-oura/restored.jpeg',
    mainImageAlt: 'why_oura_image_lifestyle_2_alt',
    auroraUiKey: 'why_oura_restored_ui',
    legacyUiKey: 'restored_app_ui_src',
  },
  {
    tagKey: 'engaged_card_tag',
    mainImageSrc: '/why-oura/lifestyle-3.jpg',
    mainImageAlt: 'why_oura_image_lifestyle_3_alt',
    auroraUiKey: 'why_oura_engaged_ui',
    legacyUiKey: 'engaged_app_ui_src',
  },
];
